var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M-85.311 0h682.67v512h-682.67z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    transform: "translate(79.98) scale(.9375)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-191.96 0h896v512h-896z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da0000",
    d: "M-191.96 343.84h896V512h-896z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.628 350.958h49.07v3.377h-49.07zM-14.312 367.842h3.377v3.28h-3.377zM27.57 367.736v3.377h-9.807v-3.377zM32.844 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.379 367.736v3.377H33.794v-3.377zM17.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.614 350.958h3.377v20.16h-3.377zM41.172 350.958h3.377v20.16h-3.377zM-3.627 358.982v3.377h-17.91v-3.377zM35.673 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 359.849h3.377v11.27h-3.377zM-21.537 359.849h3.377v11.27h-3.377zM7.27 359.849h3.376v11.27H7.27zM-7.002 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.639 367.736v3.377h-15.14v-3.377zM10.646 358.982v3.377H1.048v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-102.228 350.958h49.07v3.377h-49.07zM-94.912 367.842h3.377v3.28h-3.377zM-53.03 367.736v3.377h-9.807v-3.377zM-47.756 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.221 367.736v3.377h-18.585v-3.377zM-62.837 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.986 350.958h3.377v20.16h-3.377zM-39.428 350.958h3.377v20.16h-3.377zM-84.227 358.982v3.377h-17.91v-3.377zM-44.927 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 359.849h3.377v11.27h-3.377zM-102.137 359.849h3.377v11.27h-3.377zM-73.33 359.849h3.376v11.27h-3.377zM-87.602 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.961 367.736v3.377h-15.14v-3.377zM-69.954 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.297 350.958h49.07v3.377h-49.07zM65.613 367.842h3.376v3.28h-3.376zM107.494 367.736v3.377h-9.807v-3.377zM112.769 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.303 367.736v3.377H113.72v-3.377zM97.687 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.539 350.958h3.377v20.16h-3.377zM121.097 350.958h3.377v20.16h-3.377zM76.298 358.982v3.377h-17.91v-3.377zM115.597 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 359.849h3.377v11.27h-3.377zM58.388 359.849h3.377v11.27h-3.377zM87.194 359.849h3.377v11.27h-3.377zM72.922 359.849H76.3v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.563 367.736v3.377h-15.14v-3.377zM90.57 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.682 350.958h49.07v3.377h-49.07zM629.998 367.842h3.377v3.28h-3.377zM671.88 367.736v3.377h-9.807v-3.377zM677.154 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.689 367.736v3.377h-18.585v-3.377zM662.073 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.924 350.958h3.377v20.16h-3.377zM685.482 350.958h3.377v20.16h-3.377zM640.683 358.982v3.377h-17.91v-3.377zM679.983 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 359.849h3.377v11.27h-3.377zM622.773 359.849h3.377v11.27h-3.377zM651.58 359.849h3.376v11.27h-3.377zM637.308 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.949 367.736v3.377h-15.14v-3.377zM654.956 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.742 350.958h49.07v3.377h-49.07zM146.058 367.842h3.377v3.28h-3.377zM187.94 367.736v3.377h-9.807v-3.377zM193.214 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.749 367.736v3.377h-18.585v-3.377zM178.133 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.984 350.958h3.377v20.16h-3.377zM201.542 350.958h3.377v20.16h-3.377zM156.743 358.982v3.377h-17.91v-3.377zM196.043 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 359.849h3.377v11.27h-3.377zM138.833 359.849h3.377v11.27h-3.377zM167.64 359.849h3.376v11.27h-3.377zM153.368 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.009 367.736v3.377h-15.14v-3.377zM171.016 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.482 350.958h49.07v3.377h-49.07zM226.798 367.842h3.377v3.28h-3.377zM268.68 367.736v3.377h-9.807v-3.377zM273.954 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.489 367.736v3.377h-18.585v-3.377zM258.873 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.724 350.958h3.377v20.16h-3.377zM282.282 350.958h3.377v20.16h-3.377zM237.483 358.982v3.377h-17.91v-3.377zM276.783 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 359.849h3.377v11.27h-3.377zM219.573 359.849h3.377v11.27h-3.377zM248.38 359.849h3.376v11.27h-3.377zM234.108 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.749 367.736v3.377h-15.14v-3.377zM251.756 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#239f40",
    d: "M-191.96 0h896v168.16h-896z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.692 350.958h49.07v3.377h-49.07zM308.008 367.842h3.377v3.28h-3.377zM349.89 367.736v3.377h-9.807v-3.377zM355.164 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.699 367.736v3.377h-18.585v-3.377zM340.083 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.934 350.958h3.377v20.16h-3.377zM363.492 350.958h3.377v20.16h-3.377zM318.693 358.982v3.377h-17.91v-3.377zM357.993 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 359.849h3.377v11.27h-3.377zM300.783 359.849h3.377v11.27h-3.377zM329.59 359.849h3.376v11.27h-3.377zM315.318 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.959 367.736v3.377h-15.14v-3.377zM332.966 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.422 350.958h49.07v3.377h-49.07zM388.738 367.842h3.377v3.28h-3.377zM430.62 367.736v3.377h-9.807v-3.377zM435.894 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.429 367.736v3.377h-18.585v-3.377zM420.813 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.664 350.958h3.377v20.16h-3.377zM444.222 350.958h3.377v20.16h-3.377zM399.423 358.982v3.377h-17.91v-3.377zM438.723 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 359.849h3.377v11.27h-3.377zM381.513 359.849h3.377v11.27h-3.377zM410.32 359.849h3.376v11.27h-3.377zM396.048 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.689 367.736v3.377h-15.14v-3.377zM413.696 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.162 350.958h49.07v3.377h-49.07zM469.478 367.842h3.377v3.28h-3.377zM511.36 367.736v3.377h-9.807v-3.377zM516.634 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.169 367.736v3.377h-18.585v-3.377zM501.553 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.404 350.958h3.377v20.16h-3.377zM524.962 350.958h3.377v20.16h-3.377zM480.163 358.982v3.377h-17.91v-3.377zM519.463 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 359.849h3.377v11.27h-3.377zM462.253 359.849h3.377v11.27h-3.377zM491.06 359.849h3.376v11.27h-3.377zM476.788 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.429 367.736v3.377h-15.14v-3.377zM494.436 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.372 350.958h49.07v3.377h-49.07zM550.688 367.842h3.377v3.28h-3.377zM592.57 367.736v3.377h-9.807v-3.377zM597.844 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.379 367.736v3.377h-18.585v-3.377zM582.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.614 350.958h3.377v20.16h-3.377zM606.172 350.958h3.377v20.16h-3.377zM561.373 358.982v3.377h-17.91v-3.377zM600.673 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 359.849h3.377v11.27h-3.377zM543.463 359.849h3.377v11.27h-3.377zM572.27 359.849h3.376v11.27h-3.377zM557.998 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.639 367.736v3.377h-15.14v-3.377zM575.646 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-183.788 350.958h49.07v3.377h-49.07zM-176.472 367.842h3.377v3.28h-3.377zM-134.59 367.736v3.377h-9.807v-3.377zM-129.316 350.958h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.781 367.736v3.377h-18.585v-3.377zM-144.397 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.546 350.958h3.377v20.16h-3.377zM-120.988 350.958h3.377v20.16h-3.377zM-165.787 358.982v3.377h-17.91v-3.377zM-126.487 358.982v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 359.849h3.377v11.27h-3.377zM-183.697 359.849h3.377v11.27h-3.377zM-154.89 359.849h3.376v11.27h-3.377zM-169.162 359.849h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152.521 367.736v3.377h-15.14v-3.377zM-151.514 358.982v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.628 143.442h49.07v3.377h-49.07zM-14.312 160.326h3.377v3.28h-3.377zM27.57 160.22v3.377h-9.807v-3.377zM32.844 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.379 160.22v3.377H33.794v-3.377zM17.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.614 143.442h3.377v20.16h-3.377zM41.172 143.442h3.377v20.16h-3.377zM-3.627 151.466v3.377h-17.91v-3.377zM35.673 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 152.333h3.377v11.27h-3.377zM-21.537 152.333h3.377v11.27h-3.377zM7.27 152.333h3.376v11.27H7.27zM-7.002 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.639 160.22v3.377h-15.14v-3.377zM10.646 151.466v3.377H1.048v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-102.228 143.442h49.07v3.377h-49.07zM-94.912 160.326h3.377v3.28h-3.377zM-53.03 160.22v3.377h-9.807v-3.377zM-47.756 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-28.221 160.22v3.377h-18.585v-3.377zM-62.837 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30.986 143.442h3.377v20.16h-3.377zM-39.428 143.442h3.377v20.16h-3.377zM-84.227 151.466v3.377h-17.91v-3.377zM-44.927 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-62.837 152.333h3.377v11.27h-3.377zM-102.137 152.333h3.377v11.27h-3.377zM-73.33 152.333h3.376v11.27h-3.377zM-87.602 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-70.961 160.22v3.377h-15.14v-3.377zM-69.954 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.297 143.442h49.07v3.377h-49.07zM65.613 160.326h3.376v3.28h-3.376zM107.494 160.22v3.377h-9.807v-3.377zM112.769 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.303 160.22v3.377H113.72v-3.377zM97.687 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.539 143.442h3.377v20.16h-3.377zM121.097 143.442h3.377v20.16h-3.377zM76.298 151.466v3.377h-17.91v-3.377zM115.597 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.687 152.333h3.377v11.27h-3.377zM58.388 152.333h3.377v11.27h-3.377zM87.194 152.333h3.377v11.27h-3.377zM72.922 152.333H76.3v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.563 160.22v3.377h-15.14v-3.377zM90.57 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M622.682 143.442h49.07v3.377h-49.07zM629.998 160.326h3.377v3.28h-3.377zM671.88 160.22v3.377h-9.807v-3.377zM677.154 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.689 160.22v3.377h-18.585v-3.377zM662.073 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.924 143.442h3.377v20.16h-3.377zM685.482 143.442h3.377v20.16h-3.377zM640.683 151.466v3.377h-17.91v-3.377zM679.983 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.073 152.333h3.377v11.27h-3.377zM622.773 152.333h3.377v11.27h-3.377zM651.58 152.333h3.376v11.27h-3.377zM637.308 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.949 160.22v3.377h-15.14v-3.377zM654.956 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.742 143.442h49.07v3.377h-49.07zM146.058 160.326h3.377v3.28h-3.377zM187.94 160.22v3.377h-9.807v-3.377zM193.214 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.749 160.22v3.377h-18.585v-3.377zM178.133 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.984 143.442h3.377v20.16h-3.377zM201.542 143.442h3.377v20.16h-3.377zM156.743 151.466v3.377h-17.91v-3.377zM196.043 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.133 152.333h3.377v11.27h-3.377zM138.833 152.333h3.377v11.27h-3.377zM167.64 152.333h3.376v11.27h-3.377zM153.368 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.009 160.22v3.377h-15.14v-3.377zM171.016 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.482 143.442h49.07v3.377h-49.07zM226.798 160.326h3.377v3.28h-3.377zM268.68 160.22v3.377h-9.807v-3.377zM273.954 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.489 160.22v3.377h-18.585v-3.377zM258.873 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.724 143.442h3.377v20.16h-3.377zM282.282 143.442h3.377v20.16h-3.377zM237.483 151.466v3.377h-17.91v-3.377zM276.783 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.873 152.333h3.377v11.27h-3.377zM219.573 152.333h3.377v11.27h-3.377zM248.38 152.333h3.376v11.27h-3.377zM234.108 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.749 160.22v3.377h-15.14v-3.377zM251.756 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300.692 143.442h49.07v3.377h-49.07zM308.008 160.326h3.377v3.28h-3.377zM349.89 160.22v3.377h-9.807v-3.377zM355.164 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.699 160.22v3.377h-18.585v-3.377zM340.083 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.934 143.442h3.377v20.16h-3.377zM363.492 143.442h3.377v20.16h-3.377zM318.693 151.466v3.377h-17.91v-3.377zM357.993 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.083 152.333h3.377v11.27h-3.377zM300.783 152.333h3.377v11.27h-3.377zM329.59 152.333h3.376v11.27h-3.377zM315.318 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.959 160.22v3.377h-15.14v-3.377zM332.966 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M381.422 143.442h49.07v3.377h-49.07zM388.738 160.326h3.377v3.28h-3.377zM430.62 160.22v3.377h-9.807v-3.377zM435.894 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.429 160.22v3.377h-18.585v-3.377zM420.813 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.664 143.442h3.377v20.16h-3.377zM444.222 143.442h3.377v20.16h-3.377zM399.423 151.466v3.377h-17.91v-3.377zM438.723 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.813 152.333h3.377v11.27h-3.377zM381.513 152.333h3.377v11.27h-3.377zM410.32 152.333h3.376v11.27h-3.377zM396.048 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.689 160.22v3.377h-15.14v-3.377zM413.696 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.162 143.442h49.07v3.377h-49.07zM469.478 160.326h3.377v3.28h-3.377zM511.36 160.22v3.377h-9.807v-3.377zM516.634 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.169 160.22v3.377h-18.585v-3.377zM501.553 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.404 143.442h3.377v20.16h-3.377zM524.962 143.442h3.377v20.16h-3.377zM480.163 151.466v3.377h-17.91v-3.377zM519.463 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.553 152.333h3.377v11.27h-3.377zM462.253 152.333h3.377v11.27h-3.377zM491.06 152.333h3.376v11.27h-3.377zM476.788 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.429 160.22v3.377h-15.14v-3.377zM494.436 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M543.372 143.442h49.07v3.377h-49.07zM550.688 160.326h3.377v3.28h-3.377zM592.57 160.22v3.377h-9.807v-3.377zM597.844 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.379 160.22v3.377h-18.585v-3.377zM582.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.614 143.442h3.377v20.16h-3.377zM606.172 143.442h3.377v20.16h-3.377zM561.373 151.466v3.377h-17.91v-3.377zM600.673 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.763 152.333h3.377v11.27h-3.377zM543.463 152.333h3.377v11.27h-3.377zM572.27 152.333h3.376v11.27h-3.377zM557.998 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.639 160.22v3.377h-15.14v-3.377zM575.646 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-183.788 143.442h49.07v3.377h-49.07zM-176.472 160.326h3.377v3.28h-3.377zM-134.59 160.22v3.377h-9.807v-3.377zM-129.316 143.442h3.377v20.16h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.781 160.22v3.377h-18.585v-3.377zM-144.397 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-112.546 143.442h3.377v20.16h-3.377zM-120.988 143.442h3.377v20.16h-3.377zM-165.787 151.466v3.377h-17.91v-3.377zM-126.487 151.466v3.377h-17.91v-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-144.397 152.333h3.377v11.27h-3.377zM-183.697 152.333h3.377v11.27h-3.377zM-154.89 152.333h3.376v11.27h-3.377zM-169.162 152.333h3.377v11.27h-3.377z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-152.521 160.22v3.377h-15.14v-3.377zM-151.514 151.466v3.377h-9.598v-3.377z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#d90000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-68.83 339.507h6.048v10.505h-6.048zM91.702 339.507h6.048v10.505h-6.048zM-192.003 339.507h6.048v10.505h-6.048zM-110.528 339.507h6.048v10.505h-6.048zM-29.633 339.507h6.048v10.505h-6.048zM10.391 339.507h6.049v10.505H10.39zM51.252 339.507H57.3v10.505h-6.048zM131.727 339.507h6.048v10.505h-6.048zM334.783 339.507h6.048v10.505h-6.048zM172.586 339.507h6.048v10.505h-6.048zM212.621 339.507h6.048v10.505h-6.048zM253.059 339.507h6.048v10.505h-6.048zM293.507 339.507h6.048v10.505h-6.048zM616.65 339.507h6.047v10.505h-6.048zM373.98 339.507h6.048v10.505h-6.048zM414.84 339.507h6.049v10.505h-6.049zM456.124 339.507h6.049v10.505h-6.049zM494.9 339.507h6.049v10.505H494.9zM536.174 339.507h6.048v10.505h-6.048zM576.622 339.507h6.048v10.505h-6.048zM696.296 339.507h6.048v10.505h-6.048zM657.518 339.507h6.048v10.505h-6.048zM-151.39 339.507h6.048v10.505h-6.048z"
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt",
    fill: "#239e3f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-68.83 162.607h6.048v10.505h-6.048zM91.702 162.607h6.048v10.505h-6.048zM-192.003 162.607h6.048v10.505h-6.048zM-110.528 162.607h6.048v10.505h-6.048zM-29.633 162.607h6.048v10.505h-6.048zM10.391 162.607h6.049v10.505H10.39zM51.252 162.607H57.3v10.505h-6.048zM131.727 162.607h6.048v10.505h-6.048zM334.783 162.607h6.048v10.505h-6.048zM172.586 162.607h6.048v10.505h-6.048zM212.621 162.607h6.048v10.505h-6.048zM253.059 162.607h6.048v10.505h-6.048zM293.507 162.607h6.048v10.505h-6.048zM616.65 162.607h6.047v10.505h-6.048zM373.98 162.607h6.048v10.505h-6.048zM414.84 162.607h6.049v10.505h-6.049zM456.124 162.607h6.049v10.505h-6.049zM494.9 162.607h6.049v10.505H494.9zM536.174 162.607h6.048v10.505h-6.048zM576.622 162.607h6.048v10.505h-6.048zM696.296 162.607h6.048v10.505h-6.048zM657.518 162.607h6.048v10.505h-6.048zM-151.39 162.607h6.048v10.505h-6.048z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#da0000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.8 197.489c8.453 10.36 34.511 67.652-15.73 105.18-23.62 17.777-8.994 18.675-8.296 21.663 37.966-20.167 50.366-47.49 50.078-71.966-.29-24.476-13.266-46.102-26.052-54.873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.826 194.826c18.75 9.6 59.553 57.879 15.635 112.344 27.288-6.056 61.98-86.417-15.635-112.344zM227.245 194.826c-18.749 9.6-59.553 57.879-15.635 112.344-27.288-6.056-61.98-86.417 15.635-112.344z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.2 197.489c-8.454 10.36-34.512 67.652 15.73 105.18 23.618 17.777 8.993 18.675 8.294 21.663-37.965-20.167-50.365-47.49-50.077-71.966.289-24.476 13.265-46.102 26.052-54.873z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.198 319.111c-14.86.236-33.593-2.047-47.486-9.267 2.288 4.45 4.189 7.252 6.477 11.701 13.25 1.222 31.535 2.734 41.01-2.434zM209.225 319.111c14.86.236 33.593-2.047 47.487-9.267-2.289 4.45-4.19 7.252-6.478 11.701-13.25 1.222-31.535 2.734-41.01-2.434zM236.482 180.397c3.011 8.002 10.91 9.165 19.365 4.454 6.161 3.697 15.69 3.93 18.976-4.067 2.499 19.784-18.305 15.104-19.08 11.231-7.745 7.487-22.165 3.163-19.26-11.618z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.402 331.569l7.813-8.93 1.117-120.178-9.302-8.185-9.3 7.813 1.859 120.92 7.813 8.558z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIr);
export default __webpack_public_path__ + "static/media/ir.627eb33b33cac4acda5c7a27830cb3c9.svg";
export { ForwardRef as ReactComponent };